import { useEffect, useState } from 'react';

/**
 * Wraps a Blob in an object URL whose lifetime is tied to the component.
 * Returns null if `blob` is null/undefined, so callers can render
 * conditionally without short-circuiting hook order.
 */
export function useObjectUrl(blob: Blob | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!blob) {
      setUrl(null);
      return;
    }
    const next = URL.createObjectURL(blob);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [blob]);

  return url;
}
